import { baseApi } from './baseApi';

const toQuery = (filter = {}) => {
  const p = new URLSearchParams();
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const whatsappApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listConversations: build.query({
      query: (filter) => `/whatsapp/conversations${toQuery(filter)}`,
      transformResponse: (resp) => resp.data,
      providesTags: ['WaConversation'],
    }),
    getConversation: build.query({
      query: (id) => `/whatsapp/conversations/${id}`,
      transformResponse: (resp) => resp.data,
      providesTags: ['WaConversation'],
    }),
    listWaMessages: build.query({
      query: ({ id, ...paging }) => `/whatsapp/conversations/${id}/messages${toQuery(paging)}`,
      transformResponse: (resp) => resp.data,
      providesTags: ['WaMessage'],
    }),
    // Drives the sidebar badge. Kept separate from the list so the badge can poll cheaply.
    getInboxSummary: build.query({
      query: () => '/whatsapp/summary',
      transformResponse: (resp) => resp.data,
      providesTags: ['WaConversation'],
    }),
    // 409s when the 24-hour session window has closed — WhatsApp only accepts templates after that.
    replyToConversation: build.mutation({
      query: ({ id, text }) => ({ url: `/whatsapp/conversations/${id}/reply`, method: 'POST', body: { text } }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['WaMessage', 'WaConversation', 'Message'],
    }),
    sendConversationTemplate: build.mutation({
      query: ({ id, templateId }) => ({
        url: `/whatsapp/conversations/${id}/send-template`, method: 'POST', body: { templateId },
      }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['WaMessage', 'WaConversation', 'Message'],
    }),
    markConversationRead: build.mutation({
      query: (id) => ({ url: `/whatsapp/conversations/${id}/read`, method: 'POST' }),
      invalidatesTags: ['WaConversation'],
    }),
    linkConversation: build.mutation({
      query: ({ id, patientId, leadId }) => ({
        url: `/whatsapp/conversations/${id}/link`, method: 'POST', body: { patientId, leadId },
      }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['WaConversation'],
    }),
  }),
});

export const {
  useListConversationsQuery,
  useGetConversationQuery,
  useListWaMessagesQuery,
  useGetInboxSummaryQuery,
  useReplyToConversationMutation,
  useSendConversationTemplateMutation,
  useMarkConversationReadMutation,
  useLinkConversationMutation,
} = whatsappApi;
